<template>
  <el-card class="box-card">
    <slot/>
  </el-card>
</template>

<script>
export default {
  name: "CustomCard",
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="less" scoped>

</style>